( function($) {

	var JobAlerts = function() {
		this.modal = $( talentfunl_job_alerts.modal_selector );

		if ( this.modal.length ) {
			this.init();
		}
	};

	JobAlerts.prototype = $.extend( JobAlerts.prototype, {
		init: function() {
			this.alerts          = this.modal.find( '.alerts' );
			this.modalForm       = this.modal.find( 'form' );
			this.modalEmailField = this.modalForm.find( 'input[name="email"]' );
			this.signupButton    = this.modalForm.find( talentfunl_job_alerts.signup_btn_selector );

			this.form = $( talentfunl_job_alerts.form_selector );

			this.isIE = window.ActiveXObject || "ActiveXObject" in window;

			if ( this.form.length ) {
				this.emailField = this.form.find( 'input[name="email"]' );

				this.form.on( 'submit', $.proxy( this.onFormSubmit, this ) );
			}

			this.modalForm.on( 'submit', $.proxy( this.signup, this ) );
			this.modal.on( 'hidden.bs.modal', $.proxy( this.hideModal, this ) );
		},

		onFormSubmit: function( e ) {
			e.preventDefault();

			if ( this.form.is( ':valid' ) || this.isIE ) {
				this.openModal();
			}
		},

		openModal: function( full ) {
			if ( ! this.isModalOpen() ) {
				if (this.isIE) {
					this.modal.removeClass('fade');
				}

				this.modal.modal('show');

				if ( full ) {
					this.modal.addClass( 'full-form' );
				}

				if ( this.form.length ) {
					var data = this.form.serializeArray();

					$.each( data, $.proxy( function( index, item ) {
						var field = this.modalForm.find('input[name="' + item.name + '"]');

						if ( field.length ){
							field.val( item.value );
						}
					}, this ) );
				}

				this.form.trigger( 'jobalerts.modal.open', [ this.modal ] );

				this.modalForm.find( 'select' ).selectize( {
					plugins: ['remove_button'],
					delimiter: ',',
					persist: false
				} );
			}

			return this.modal;
		},

		hideModal: function() {
			this.modal.removeClass( 'full-form' );
		},

		isModalOpen: function() {
			modalData = this.modal.data('bs.modal');

			return ( modalData && modalData._isShown );
		},

		signup: function( e ) {
			e.preventDefault();

			this.alerts.empty();
			this.signupButton.addClass( 'sending' ).prop( 'disabled', true );

			var data = {
				action: 'talentfunl/job_alerts_signup',
				nonce : talentfunl_job_alerts.nonce,
				form  : this.modalForm.serialize()
			};

			this.modalForm.trigger( 'jobalerts.beforesubmit', [ this.modalForm ] );

			$.post( talentfunl_job_alerts.ajaxurl, data, $.proxy( this.complete, this ) )
				.fail( $.proxy( this.fail, this ) );
		},

		complete: function( response ) {

			var alertType = 'danger';

			if ( response.success ) {
				alertType = 'success';
				this.modalForm.find( '.hide-after-signup' ).slideUp();
			}

			this.addAlert( response.data, alertType );

			this.signupButton.removeClass( 'sending' ).prop( 'disabled', false );
		},

		fail: function( response ) {

			this.addAlert( talentfunl_job_alerts.error_message, 'danger' );
			this.signupButton.removeClass( 'sending' ).prop( 'disabled', false );

		},

		addAlert: function( message, type ) {

			var alert = $( document.createElement( 'div' ) );

			alert.attr( 'role', 'alert' )
				.addClass( 'alert' )
				.addClass( 'alert-' + type )
				.text( message )
				.appendTo( this.alerts );
		}
	} );

	$( 'document' ).ready( function() {

		window.JobAlerts = new JobAlerts();

	} );

} )( jQuery );
